import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

export interface IContextClient {
    /**
     * Založení kontextu
     *
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     * @returns ID vytvořeného kontextu
     */
    createContext(cancellationToken?: CancellationToken): Promise<string>;

    /**
     * Ukončení kontextu a potvrzení kontextu
     *
     * @param contextId identifikátor kontextu
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     * @returns Informaci o úspěšném ukončení kontextu
     */
    commitContext(contextId: string, cancellationToken?: CancellationToken): Promise<boolean>;

    /**
     * Ukončí kontext zahozením změn
     *
     * @param contextId identifikátor kontextu
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     * @returns Informaci o úspěšném ukončení kontextu
     */
    rollbackContext(contextId: string, cancellationToken?: CancellationToken): Promise<boolean>;
}
